
export default {
  // Režimy
  "common.mode.auto": "Automatický režim využívání obnovitelných energií",
  "common.mode.economy": "Ekonomický režim",
  "common.mode.exigency": "Režim nouze",

  // Zařízení
  "common.grid": "Elektrická síť",
  "common.evChargers": "Nabíječky pro elektromobily (více)",
  "common.evCharger": "Nabíječka pro elektromobil",
  "common.pv": "Fotovoltaika (PV)",
  "common.inverter": "Invertor (zařízení pro přeměnu elektrické energie)",
  "common.pcs": "Invertor + baterie",
  "common.terminal": "Terminální zařízení",
  "common.airc": "Klima (AC)",
  "common.engine": "Motor",
  "common.battery": "Baterie",
  "common.metter": "Elektroměr",
  "common.other": "Ostatní",
  "common.power": "Výkon",
  "common.powerTotal": "Celkový výkon",
  "common.voltage": "Napětí",
  "common.electricity": "Elektřina",
  "common.current": "Proud",
  "common.homeUsage": "Celková domácí zátěž",
  "common.battery.power": "Výkon baterie",

  // Data
  "common.noDataAvailable": "Žádná data nejsou momentálně k dispozici~",
  "common.tips": "Tipy",
  "common.reset": "Obnovit (vymazat)",
  "common.currencyUnit": "¥ (Juan)",
  "common.submiting": "Odesílání... Prosím čekejte...",
  "common.close": "Zavřít",
  "common.from": "Od",
  "common.useIn": "Pro",
  "common.energyPercent": "Procento energie",
  "common.dataFlow": "Tok dat",
  "common.getDataIng": "Získávání dat... Prosím čekejte...",
  "common.pageLoading": "Načítání stránky... Prosím čekejte...",
  "common.reseting": "Obnovování stránky... Prosím čekejte...",
  "common.save": "Uložit",
  "common.onlyNumberTips": "Můžete zadat pouze čísla",
  "common.offline": "Offline (není připojeno k internetu)",
  "common.online": "Online (připojeno k internetu)",
  "common.fault": "Chyba (problém)",
  "common.charge": "Nabít (baterii)",
  "common.discharge": "Rozdát (používat energii z baterie)",
  "common.buy": "Koupit",
  "common.sell": "Prodat",
  "common.loadingInfo": "Načítání... Prosím čekejte...",

  // Obecné funkce
  "common.moreFeatures": "Více funkcí",
  "common.confirm": "Potvrdit",
  "common.saveing": "Ukládání... Prosím čekejte...",
  "common.searchPlacholder": "Zadejte klíčové slovo pro hledání",
  "common.iSee": "Rozumím",
  "common.pageErrorTips1": "Ach, došlo k chybě na stránce~",
  "common.pageErrorTips2": "Obnovte stránku nebo kontaktujte podporu~",
  "common.refresh": "Obnovit",
  "common.backToHome": "Zpět na domovskou stránku",
  "common.checkTips": "Kontrola... Prosím čekejte...",
  "common.back": "Zpět",
  "common.cancel": "Zrušit (smazat)",
  "common.optional": "Volitelný (není povinný)",
  "common.required": "Povinné k vyplnění",
  "common.status": "Stav",
  "common.statusNoDelete": "Nesmazáno",
  "common.statusDelete": "Smazáno",
  "common.submit": "Odeslat",
  "common.disable": "Deaktivovat",
  "common.enable": "Aktivovat",
  "common.year": "Rok",
  "common.month": "Měsíc",
  "common.day": "Den",
  "common.version": "Verze:",
  "common.backHome": "Zpět na domovskou stránku",
  "common.backHomeSorry": "Omlouvám se, stránka je neplatná",
  "common.requestTips1": "Získávání dat probíhá, nepříště neodešlete",
  "common.requestTips2": "Systémová oznámení",
  "common.requestTips3": "Relace přihlášení vypršela, prosím přihlaste se znovu",
  "common.requestTips4": "Znovu přihlásit",
  "common.requestTips5": "Přihlášení není platné nebo relace vypršela, prosím přihlaste se znovu.",
  "common.requestTips6": "Chyba serveru, zkuste to prosím později.",
  "common.requestTips7": "Systémová žádost vypršela časový limit",
  "common.requestTips8": "Systémové rozhraní",
  "common.requestTips9": "Chyba",
  "common.iknow": "Rozumím",
  "common.logoutSuccess": "Úspěšné odhlášení",
  
  // Další informace
  "common.knowMore.title": "Pro více informací kontaktujte Beineng",
  "common.knowMore.email": "Email pro kontakt",
  "common.knowMore.phone": "Telefon pro kontakt",
  "common.knowMore.wechat": "WeChat pro kontakt",
  "common.knowMore.website": "Oficiální webová adresa",
  "common.knowMore.address": "Adresa pro kontakt",
  "common.knowMore.addressDetail": "Místnost 1205, 1301, Budova 5, Ulice Qingxi 8, Obec Huaning, Město Nanjing, Provincie Jiangsu",
  
  // Lokální připojení
  "common.localConnection": "Lokální připojení",
  "common.operateInApp": "Proveďte operace v aplikaci!",
  
  "common.enbleStaus": "Stav aktivace",
  "common.battery.status": "Není nabíjeno, není použito",

  // Související s účtem
  "account.forgetThePassword": "Zapomněl jsem heslo",
  "account.logInDirectly": "Přímé přihlášení",
  "account.tips1": "Přesměrování na stránku... Prosím čekejte...",
  "account.tips2": "Nejprve přečtěte a přijměte podmínky použití!",
  "account.autoLogin": "Automatické přihlášení",
  "account.userLogin": "Přihlášení uživatele",
  "account.registerTips": "Nemáte účet? Klikněte zde pro registraci",
  "account.userEmail": "Uživatelské jméno / Email",
  "account.userEmailTips": "Zadejte uživatelské jméno nebo email",
  "account.password": "Heslo",
  "account.passwordTips": "Zadejte heslo",
  "account.submit": "Odeslat",
  "account.submitTips": "Odesílání... Prosím čekejte...",
  "account.otherLoginTips": "Nebo vyberte jinou metodu přihlášení",
  "account.userRegistration": "Registrace uživatele",
  "account.userName": "Uživatelské jméno",
  "account.userNameTips": "Zadejte uživatelské jméno",
  "account.emailTips1": "Zadejte emailovou adresu",
  "account.emailTips2": "Neplatný formát emailu",
  "account.phone": "Telefon",
  "account.phoneTips1": "Zadejte telefonní číslo",
  "account.phoneTips2": "Neplatné telefonní číslo",
  "account.phoneTips3": "Zadejte telefonní číslo",
  "account.passwordTips1": "Zadejte heslo (6-30 znaků)",
  "account.passwordTips2": "Neplatný formát hesla: Heslo musí obsahovat anglické písmena, čísla, podtržítko (_), pomlčku (-) a tečku (.), délka 6-12 znaků",
  "account.passwordTips3": "Dvě zadaná hesla nejsou stejná, prosím zkontrolujte a zadejte znovu!",
  "account.passwordTips4": "Zadejte heslo: Heslo musí obsahovat anglické písmena, čísla, podtržítko (_), pomlčku (-) a tečku (.)",
  "account.passwordTips5": "Potvrzení hesla",
  "account.passwordTips6": "Zadejte pro potvrzení hesla",
  "account.passwordTips7": "Dvě zadaná hesla nejsou stejná, prosím zkontrolujte a zadejte znovu!",
  "account.passwordTips8": "Zadejte pro potvrzení hesla",
  "account.passwordTips9": "Gratulujeme, registrace byla úspěšná!",
  "account.passwordTips10": "Vaše uživatelské jméno je:",
  "account.emailIs": "Váš email je:",
  "account.goToLoginPage": "Budeš automaticky přesměrován na přihlašovací stránku za s sekund",
  "account.goLogin": "Přihlásit",
  "account.goRegister": "Registrovat",
  "account.loginSuccess": "Úspěšné přihlášení",
  "account.email": "Email",
  "account.sologn": "Vytváříme integrovanou energiovou platformu speciálně navrženou pro vás",
  "account.pleaseAgree": "Přečetl jsem a souhlasím s",
  "userAgreement.privacyPolicy": "Zásady ochrany soukromí",

  // Související s ověřovacím kódem
  "account.code": "Ověřovací kód",
  "account.codeTips": "Zadejte ověřovací kód",
  "account.codeTips2": "Neplatný ověřovací kód",

    "account.inviteCodeTips": "Zadejte prosím zvací kód",
    "account.inviteCodeHint": "Pro získání zvacího kódu kontaktujte prosím instalatéra nebo provozní personál",
  // Změna a obnovení hesla
  "account.modifyPasswordByAccount": "Změna hesla prostřednictvím účtu",
  "account.modifyPasswordByEmail": "Změna hesla prostřednictvím emailu",
  "account.getPasswordByAccount": "Získání hesla prostřednictvím účtu",
  "account.getPasswordByEmail": "Získání hesla prostřednictvím emailu",

  "account.sendEmailTips": "Ověřovací kód byl odeslán na email, prosím zkontrolujte",
  "account.name": "Název účtu",
  "account.newPassword": "Nové heslo",
  "account.confirmNewPassword": "Potvrzení nového hesla",
  "account.nameTips": "Zadejte název účtu",
  "account.passwordModifySuccess": "Změna hesla byla úspěšná",
  "account.emailCode": "Emailový ověřovací kód",
  "account.emailCodeTips": "Zadejte emailový ověřovací kód",
  "account.emailCodeTips2": "Neplatný emailový ověřovací kód",
  "account.emailModifySuccess": "Změna hesla byla úspěšná",
  "account.passworTips1": "Vaše heslo bylo obnoveno!",
  "account.passwordTips11": "Zadejte pro potvrzení hesla",
  "account.passwordTips12": "Zadejte nové heslo",
  "account.nickname": "Přezdívka",
  "account.modifyNickname": "Změna přezdívky",
  "account.modifyNicknameSuccess": "Změna přezdívky byla úspěšná!",
  "account.nicknameTips": "Zadejte přezdívku",
  "account.nicknameError": "Změna přezdívky selhala!",

  // Rychlá registrace a přihlášení
  "account.login": "Přihlásit",
  "account.quickRegister": "Rychlá registrace",
  "account.sendCode": "Odeslat kód",
  "account.sendTips": "Může být odeslán znovu za s sekund",
  "account.sendEmailIng": "Odesílání emailu... Prosím čekejte...",
  "account.emailNotEmpty": "Pole email nemůže být prázdné",
  "account.registerAccount": "Registrace účtu",
  "account.registerWelcome": "Vítejte v registraci SusprSafe",
  "account.usernameLimit": "Uživatelské jméno musí začínat písmenem, může obsahovat pouze písmena, čísla a podtržítko (_), délka 5-15 znaků",

  // Informace o autorských právech
  "copyright.desc2": "Informace o registraci webu: IČP Provincie Jiangsu 2021169764",

  // Úprava uživatelských informací
  "editUserInfo.editUserInformation": "Úprava uživatelských informací",
  "editUserInfo.modifyUsername": "Změna uživatelského jména",
  "editUserInfo.changePictures": "Změna profilového obrázku",
  "editUserInfo.savePicturesSuccess": "Uložení profilového obrázku bylo úspěšné",
  "editUserInfo.saveError": "Uložení selhalo",
  "editUserInfo.pictureLimit": "Velikost obrázku nesmí překročit 2 MB",
  "editUserInfo.uploadPicture": "Nahrání profilového obrázku",
  "editUserInfo.picturePreview": "Náhled",
  
  "editUserInfo.bindPhoneNumber": "Propojení telefonního čísla",
  "editUserInfo.bindEmail": "Propojení emailu",
  "editUserInfo.changePassword": "Změna hesla",

  "editUserInfo.notificationSettings": "Nastavení oznámení",
  "editUserInfo.editAccount": "Úprava informací o účtu",
  "editUserInfo.waitBingting": "Propojování... Prosím čekejte...",
  "editUserInfo.collapse": "Sbalit (oddělit)",
  "editUserInfo.modifyBinding": "Změna propojení",
  
  "editUserInfo.emailAddress": "Emailová adresa",
  "editUserInfo.tips1": "Propojení emailu bylo úspěšné",
  "editUserInfo.tips2": "Uložení selhalo",
  "editUserInfo.tips3": "Odesílání emailového ověřovacího kódu... Prosím čekejte...",
  "editUserInfo.tips4": "Ověřovací kód byl odeslán na email xxxx, prosím zkontrolujte",
  "editUserInfo.tips5": "Odeslání ověřovacího kódu selhalo!",
  "editUserInfo.tips6": "Telefonní číslo bylo propojeno",
  "editUserInfo.tips7": "Email byl propojen",
  "editUserInfo.emailTips1": "Zadejte emailovou adresu",
  "editUserInfo.emailTips2": "Neplatný formát emailu",
  "editUserInfo.emailTips3": "Může být odeslán znovu za xxxx sekund",
  "editUserInfo.emailTips4": "Odeslat kód",
  "editUserInfo.emailTips5": "Pole emailového ověřovacího kódu nemůže být prázdné",
  "editUserInfo.emailTips6": "Neplatný emailový ověřovací kód",
  "editUserInfo.emailCode": "Emailový ověřovací kód",
  "editUserInfo.save": "Uložit",

  // Související s propojením telefonu
  "editUserInfo.phoneTips1": "Propojení telefonního čísla bylo úspěšné",
  "editUserInfo.phoneTips2": "Odesílání SMS ověřovacího kódu... Prosím čekejte...",
  "editUserInfo.phoneTips3": "SMS ověřovací kód byl odeslán na číslo xxxx, prosím zkontrolujte",
  "editUserInfo.phoneTips4": "Odeslání SMS ověřovacího kódu selhalo!",
  "editUserInfo.phoneTips5": "Zadejte telefonní číslo",
  "editUserInfo.phoneTips6": "Neplatný formát telefonního čísla",
  "editUserInfo.phoneTips7": "Odeslat SMS ověřovací kód",
  "editUserInfo.phoneTips8": "SMS ověřovací kód",
  "editUserInfo.phoneTips9": "Pole SMS ověřovacího kódu nemůže být prázdné",
  "editUserInfo.phoneTips10": "Neplatný SMS ověřovací kód",
  "editUserInfo.phone": "Telefonní číslo",


  // Nastavení oznámení
  "editUserInfo.noticeTips1": "Získání nastavení oznámení selhalo!",
  "editUserInfo.noticeTips2": "Uložení nastavení oznámení bylo úspěšné!",
  "editUserInfo.noticeTips3": "Oznámení o nízkém stavu baterie",
  "editUserInfo.noticeTips4": "Oznámení o dokončení nabití nabíječky",
  "editUserInfo.errorNotification": "Oznámení o chybě",
  "editUserInfo.updateNotification": "Oznámení o aktualizaci",
  "editUserInfo.monthlyStatisticsNotification": "Oznámení o měsíčních statistikách",
  "editUserInfo.notificationMethod": "Způsob přijetí",

  // Tipy související s uživatelským jménem
  "editUserInfo.userNameTips1": "Uložení uživatelského jména bylo úspěšné",
  "editUserInfo.userNameTips2": "Uložení uživatelského jména selhalo",
  "editUserInfo.userNameTips3": "Zadejte uživatelské jméno",
  "editUserInfo.userNameTips4": "Neplatný formát uživatelského jména: Může obsahovat pouze čísla, podtržítko (_) a anglická písmena",
  "editUserInfo.userNameTips5": "Zadejte uživatelské jméno",
  "editUserInfo.userNameTips6": "Ukládání... Prosím čekejte...",
  "editUserInfo.userName": "Uživatelské jméno",

  // Tipy pro úpravu profilového obrázku
  "editUserInfo.avatorTips": "Klikněte pro změnu profilového obrázku",
  "editUserInfo.verifyCodeTips1": "Zadejte obdržený ověřovací kód:",
  "editUserInfo.verifyCodeTips2": "Pro bezpečnost vašeho účtu klikněte na tlačítko níže pro odeslání ověřovacího kódu na původní telefonní číslo:",
  "editUserInfo.verifyCodeTips3": "Odeslat kód",
  "editUserInfo.verifyCodeTips4": "Ověření původního telefonního čísla bylo úspěšné, zadejte nové telefonní číslo k propojení",
  "editUserInfo.verifyCodeTips5": "Pro bezpečnost vašeho účtu klikněte na tlačítko níže pro odeslání ověřovacího kódu na původní email:",
  "editUserInfo.verifyCodeTips6": "Ověření původního emailu bylo úspěšné, zadejte nový email",
  "editUserInfo.verifyCodeTips7": "Staré heslo",
  "editUserInfo.verifyCodeTips8": "Nejprve propojte email!",
  "editUserInfo.verifyCodeTips9": "Ověovací kód byl odeslán na email, prosím zkontrolujte",
  "editUserInfo.verifyCodeTips10": ", budeš automaticky přesměrován na přihlašovací stránku",

  // Související s oznámeními
  "hems.notice.title": "Nadpis oznámení", 
  "hems.notice.content": "Obsah oznámení", 
  "hems.notice.operate": "Operace",
  "hems.notice.noRead": "Nepřečtené",
  "hems.notice.read": "Přečtené",
  "hems.notice.warning": "Varování",
  "hems.notice.error": "Chyba",
  "hems.notice.success": "Statistická výpočet",
  "hems.notice.sys": "Systémové informace",
  "hems.notice.operateSuccess": "Operace byla úspěšná",
  "hems.notice.operateTips": "Vyberte prvek pro operaci",

  // Domovská stránka
  "hems.home.selfuseRate": "Procento vlastní využití",
  "hems.home.percent": "Procento",
  "hems.home.todayData": "Dnešní data",
  "hems.home.todayPowerGeneration": "Dnešní výroba energie",
  "hems.home.salesIncome": "Příjmy z prodeje energie",
  "hems.home.saved": "Ušetřili jste",
  "hems.home.reduce": "Snížení uhlíkového stopy",
  "hems.home.tips1": "Žádná data nejsou momentálně k dispozici, ještě jste nepřipojili xxxx",
  "hems.home.criticalLoad": "Kritická zátěž",
  "hems.home.keyVoltage": "Kritické napětí",
  "hems.home.householdLoad": "Domácí zátěž",
  "hems.home.householdVoltage": "Domácí napětí",
  "hems.home.generalLoad": "Obecná zátěž",
  "hems.home.generalVoltage": "Obecné napětí",
  "hems.home.batteryHealth": "Stav zdraví baterie",
  "hems.home.averageTemp": "Průměrná teplota",
  "hems.home.gridLoad": "Zátěž elektrické sítě",
  "hems.home.toggeleDataSource": "Zobrazovaná data byla změněna následovně:",
  "hems.home.toggleTips": "Chcete změnit?",
  "hems.home.modeSending": "Odesílání režimové příkazu... Prosím čekejte...",
  "hems.home.modeSuccess": "Změna režimu byla úspěšně odeslána!",
  "hems.home.isOnline": "Je připojeno?",
  "hems.home.useStatus": "Stav využití",
  "hems.home.workModeText": "Aktuální pracovní režim:",
  "hems.home.toggleDataSourceText": "Zobrazovaná data byla změněna následovně:",
  "hems.ev.charge.status": "Stav nabití",
  "hems.ev.charge.time": "Čas nabití",
  "hems.ev.charge.count": "Skutečný počet nabití (v průběhu času)",
  "hems.ev.charge.status.empty": "Prázdné",
  "hems.ev.charge.status.ing": "Připojeno k baterii. Nabíjí",
  "hems.ev.charge.status.null": "Připojeno k baterii, ale nenabíjí",
  "hems.ev.charge.status.error": "Chyba",
  "hems.hour": "Hodina",
  "hems.minue": "Minuta",
  "hems.ev.chagre.number": "Číslo nabíječky",

  // Návod k použití
  "hems.userGuide.selfUse": "Vlastní využití obnovitelných energií",
  "hems.userGuide.selfUseTips": "Nejprve použijte sluneční energii, pokud není dostatečná, doplňte elektrickou síti",
  "hems.userGuide.economyMode": "Ekonomický režim",
  "hems.userGuide.economyModeTips": "Optimalizace strategie využití energie na základě cen elektřiny",
  "hems.userGuide.emergencyMode": "Režim nouze",
  "hems.userGuide.emergencyModeTips": "Prioritizace podpory energie pro kritické zátěže",

  // Stránka grafů
  "hems.history.energyStatistics": "Energetické statistiky",
  "hems.history.revenueStatistics": "Statistiky příjmů",
  "hems.history.greenStatistics": "Snížení emisí skleníkových plynů",
  "hems.history.revenueTitle": "Celkové příjmy z prodeje energie",
  "hems.history.savingsTitle": "Celková úspora",
  "hems.history.carbonTitle": "Celkové snížení uhlíku",
  "hems.history.day": "Den",
  "hems.history.month": "Měsíc",
  "hems.history.year": "Rok",
  "hems.history.beforeDay": "Předchozí den",
  "hems.history.afterDay": "Další den",
  "hems.history.beforeMonth": "Předchozí měsíc",
  "hems.history.afterMonth": "Další měsíc",
  "hems.history.beforeYear": "Předchozí rok",
  "hems.history.afterYear": "Další rok",
  "hems.history.totalUse": "Celkové využití",
  "hems.history.fullScreen": "Celá obrazovka",
  "hems.history.timeSelect": "Vyberte den",
  "sync.tips1": "Příkaz synchronizace dat byl úspěšně odeslán!",
  "sync.tips2": "Synchronizace dat trvá čas kvůli velkému objemu dat, zkontrolujte znovu za 50 minut~",
  "sync.tips3": "Synchronizace dat zařízení může být zpožděna, pokud zaznamenáte nesrovnalosti v datech, klikněte na tlačítko níže:",
  "sync.tips4": "Synchronizovat data",

  // Informace o nabíječce
  "charge.info": "Informace o nabíječce",
  "news.loading": "Načítání...",
  "news.noMore": "Žádná další data",
  "hems.pv.power": "Množství sluneční energie",

  // Specifické funkce UEH
  "ueh.sellPower": "Množství energie k prodeji",
  
  // Menu
  "menu.home": "Domovská stránka",
  "menu.history": "Historická data",
  "menu.device": "Zařízení",
  "menu.settings": "Nastavení",
  "menu.messageCenter": "Centrum zpráv",
  "menu.help": "Nápověda a podpora",
  "menu.mine": "Já (osobní)",


  // Moje nastavení
  "mine.userSetting": "Uživatelská nastavení",
  "mine.terminalSetting": "Základní nastavení terminálového zařízení",
  "mine.uploadCloud": "Nahrání dat do cloudu",
  "mine.changeVersion": "Kontrola aktualizací",
  "mine.language": "Změna jazyka",
  "mine.about": "O aplikaci",
  "mine.feedback": "Zpětná vazba",
  "mine.logout": "Odhlásit se",
  "mine.logoutAccount": "Smazat účet",

  // Související s mazáním účtu
  "mine.logoutAccountTips": "Smazat účet s názvem []",
  "mine.logoutAccountTips1": "Smazat účet propojený s []",
  "mine.logoutAccountCare": "Poznámky k žádosti o smazání účtu:",
  "mine.logoutAccountCare1": "1. Účet je v plně bezpečném stavu",
  "mine.logoutAccountCare1-1": "Účet funguje normálně, neexistuje riziko krádeže, porušení pravidel nebo uzavření",
  "mine.logoutAccountCare2": "2. Přístupová práva a propojení účtu se smazou",
  "mine.logoutAccountCare2-1": "Všechna přístupová práva účtu pro třetí strany se smazou",
  "mine.logoutAccountCare3": "3. Po smazání se účet nemůže obnovit, uživatelská data se smazou",
  "mine.logoutAccountCare3-1": "Po smazání se smažou telefonní číslo, email a související data, která jsou propojena, a nelze je obnovit",
  "mine.confirmLogout": "Potvrdit smazání",
  "mine.logoutSuccess": "Účet byl úspěšně smazán!",


  // Problémy s zpětnou vazbou
  "mine.feedbackIssues": "Problémy a zpětná vazba",
  "mine.feedQuantity": "Množství",
  "mine.feedAmount": "Maximálně 9 obrázků, maximální velikost každého obrázku 1 MB",

  // Související s nastavením oznámení
  "mine.notice.fail": "Získání nastavení oznámení selhalo!",
  "mine.notice.saveSuccess": "Uložení nastavení oznámení bylo úspěšné!",
  "mine.notice.saveFail": "Uložení selhalo!",
  "mine.notice.title": "Nastavení oznámení",
  "mine.notice.batteryLow": "Oznámení o nízkém stavu baterie",
  "mine.notice.chargingFinish": "Oznámení o dokončení nabití nabíječky",
  "mine.notice.error": "Oznámení o chybě",
  "mine.notice.update": "Oznámení o aktualizaci",
  "mine.notice.monthly": "Oznámení o měsíčních statistikách",
  "mine.notice.receiveType": "Způsob přijetí",

  // Vítejte v nastavení jazyka
  "mine.language.welcome": "Vítejte v SusprSafe",
  "mine.language.desc1": "Vyberte jazykovou verzi podle umístění vašeho domu",
  "mine.language.desc2": "Můžete ji kdykoliv změnit v nastavení aplikace",

  // Osobní informace
  "mine.userInfo.avatar": "Profilový obrázek",
  "mine.userInfo.nickname": "Přezdívka",
  "mine.userInfo.password": "Heslo",
  "mine.userInfo.changePassword": "Změna hesla",
  "mine.userInfo.setPassword": "Nastavení hesla",
  "mine.userInfo.phoneNumber": "Telefonní číslo",
  "mine.userInfo.bindPhone": "Propojit telefon",
  "mine.userInfo.bindEmail": "Propojit email",
  "mine.loginExpired": "Relace přihlášení vypršela, prosím přihlaste se znovu",
  "mine.userInfo.title": "Uživatelské informace",
  "mine.userInfo.bind": "Propojit",
  "mine.userInfo.modify": "Upravit",
  "mine.userInfo.modifyNickname": "Změna přezdívky",
  "mine.userInfo.userNickname": "Uživatelská přezdívka",
  "mine.userInfo.selectPic": "Vyberte obrázek k nahrání",
  "mine.userInfo.saveSuccess": "Uložení bylo úspěšné",
  "mine.userInfo.uploadFail": "Nahrání selhalo",
  "mine.userInfo.avatarSaveSuccess": "Uložení profilového obrázku bylo úspěšné",
  "mine.userInfo.nameTips1": "Pole přezdívky nemůže být prázdné",
  "mine.userInfo.nameTips2": "Zadejte přezdívku",

  // Obecné tipy pro výběr
  "common.pleaseSelect": "Prosím vyberte",
  "question.commonQuestions": "Časté otázky",
  "account.toggleLanguage": "Změna jazyka",
  "account.localConnection": "Lokální připojení",
  "account.selectLanguage": "Prosím vyberte jazyk",
  "account.sendEmailToast": "Ověovací kód byl odeslán na email xxx, prosím zkontrolujte",
  "account.emailError": "Neplatný formát emailu",
  "account.sendEmailFail": "Odeslání selhalo, prosím zkuste znovu",
  
  "common.submitting": "Odesílání... Prosím čekejte...",

  "device.page.noData": "Žádná data nejsou momentálně k dispozici, tato stránka může být zobrazena pouze v aplikaci"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};